const zh_CN = {
  type: '数据源类型',
  id: '关联数据源',
};
export default zh_CN;
